import styles from "./modal.module.css";
import { createPortal } from "react-dom";
import { useEffect, useState } from "react";
import { UIIconButton } from "BEDROCK/components/ui-icon-drawing/ui-icon-button";

interface ModalProps {
  children: React.ReactNode;
  showCloseButton?: boolean;
  onClose: () => void;
  isOpen: boolean;
}

export const Modal = ({
  children,
  showCloseButton = true,
  onClose,
  isOpen,
}: ModalProps) => {
  const [isBrowser, setIsBrowser] = useState(false);

  useEffect(() => {
    setIsBrowser(true);
  }, []);

  if (!isOpen) {
    return null;
  }

  const modalContent = (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        {showCloseButton && (
          <UIIconButton
            className={styles.close}
            iconName="REMOVE"
            onClick={onClose}
          />
        )}
        {children}
      </div>
    </div>
  );

  if (isBrowser && isOpen) {
    return createPortal(modalContent, document.body);
  } else {
    return null;
  }
};
